<template>
  <div>
    <div class="bot van-multi-ellipsis--l5" @click="ViewRemark()">
      {{ remark }}
    </div>
    <van-popup v-model="show" class="pop_content">{{ remark }}</van-popup>
  </div>
</template>

<script>
import { Popup } from 'vant';
export default {
  props: {
    remark: {
      type: [String, Number],
    },
  },
  data() {
    return {
      show: false,
    };
  },
  components: {
    'van-popup': Popup,
  },
  methods: {
    ViewRemark() {
      this.show = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.bot {
  padding: 20px 0px !important;
  color: #666666;
  padding: 10px 0;
  box-sizing: border-box;
  border-top: 2px solid #f4f5f5;
  height: auto;
  word-wrap: break-word;

  word-break: normal;
}
.pop_content {
  width: 600px;
  word-wrap: break-word;
  padding: 10px;
  word-break: normal;
}
</style>
